import badgeData from './badgeData';
import widgetInfo from './widgetInfo';

const root = {
	badgeData,
	widgetInfo
};

export default root;
